<template>
  <table-ag
    v-if="data && tokenUser && empresa"
    ref="tableCompanies"
    class="table-company"
    :rowData="data"
    :columnDefs="columns"
    :components="components"
    :component-menu="componentMenu"
    :actions="true"
    :suppressRowClickSelection="true"
    :isExternalFilterPresent="isExternalFilterPresent"
    :doesExternalFilterPass="doesExternalFilterPass"
    :rowPinning="rowPinningData"
  ></table-ag>
</template>
<script>
import apiServices from "@/services/yungol-services";

import tableAg from "../../dashboard/tableAg.vue";
import buttonsActionCompany from "./ButtonsActionCompany.vue";
import menuTableCompany from "./MenuTableCompany.vue";
import tooltipDiagnosis from "./TooltipDiagnosis.vue";
import cellSelectCompany from "./CellSelectCompany.vue";
import cellHeaderIcon from "./CellHeaderIcon.vue";
import { mapState } from "vuex";

export default {
  data() {
    return {
      columns: [
        {
          field: "_id",
          headerName: "",
          cellRenderer: "CellSelectCompany",
          width: "50px",
          sortable: false,
          editable: false,
          getQuickFilterText: (params) => {
            return null;
          },
          tooltipValueGetter: (params) => {
            return "Seleccionar empresa";
          },
          cellStyle: {
            display: "flex",
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            "padding-right": "5",
          },
        },
        {
          field: "nombre",
          headerName: "Nombre",
          filter: "agTextColumnFilter",
          editable: false,
          getQuickFilterText: (params) => {
            return params.data.namesearch;
          },
          tooltipValueGetter: (params) => {
            return params.value;
          },
        },
        {
          field: "climaOld",
          headerName: "ECO",
          editable: false,
          filter: "agTextColumnFilter",
          width: "140px",
          cellRenderer: (params) => {
            return this.formatStatus(params);
          },
          getQuickFilterText: (params) => {
            return `cilma ${params.value}`;
          },
          onCellClicked: (params) => this.handerCellClicked(params),
          cellStyle: {
            display: "flex",
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            "padding-right": "5",
          },
          tooltipField:
            this.tokenUser && !this.tokenUser.admin ? null : "climaOld",
          tooltipComponent:
            this.tokenUser && !this.tokenUser.admin ? null : "TooltipDiagnosis",
        },
        {
          field: "clima",
          headerName: "Cl7",
          editable: false,
          filter: "agTextColumnFilter",
          width: "140px",
          cellRenderer: (params) => {
            return this.formatStatus(params);
          },
          getQuickFilterText: (params) => {
            return `cl7 ${params.value}`;
          },
          onCellClicked: (params) => this.handerCellClicked(params),
          cellStyle: {
            display: "flex",
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            "padding-right": "5",
          },
          tooltipField:
            this.tokenUser && !this.tokenUser.admin ? null : "clima",
          tooltipComponent:
            this.tokenUser && !this.tokenUser.admin ? null : "TooltipDiagnosis",
        },
        {
          field: "frp",
          headerName: "FRPv21",
          editable: false,
          filter: "agTextColumnFilter",
          width: "140px",
          cellRenderer: (params) => {
            return this.formatStatus(params);
          },
          getQuickFilterText: (params) => {
            return `frp ${params.value}`;
          },
          onCellClicked: (params) => this.handerCellClicked(params),
          cellStyle: {
            display: "flex",
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            "padding-right": "5",
          },
          tooltipField: this.tokenUser && !this.tokenUser.admin ? null : "frp",
          tooltipComponent:
            this.tokenUser && !this.tokenUser.admin ? null : "TooltipDiagnosis",
          headerTooltip: "header",
        },
        {
          field: "frpNew",
          headerName: "FRPv23",
          editable: false,
          filter: "agTextColumnFilter",
          width: "140px",
          cellRenderer: (params) => {
            return this.formatStatus(params);
          },
          getQuickFilterText: (params) => {
            return `frp nuevo ${params.value}`;
          },
          onCellClicked: (params) => this.handerCellClicked(params),
          cellStyle: {
            display: "flex",
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            "padding-right": "5",
          },
          tooltipField:
            this.tokenUser && !this.tokenUser.admin ? null : "frpNew",
          tooltipComponent:
            this.tokenUser && !this.tokenUser.admin ? null : "TooltipDiagnosis",
          headerTooltip: "header",
        },
        {
          field: "cultura",
          headerName: "Cultura",
          editable: false,
          filter: "agTextColumnFilter",
          width: "140px",
          cellRenderer: (params) => {
            return this.formatStatus(params);
          },
          getQuickFilterText: (params) => {
            return `cultura ${params.value}`;
          },
          onCellClicked: (params) => this.handerCellClicked(params),
          cellStyle: {
            display: "flex",
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            "padding-right": "5",
          },
          tooltipField:
            this.tokenUser && !this.tokenUser.admin ? null : "cultura",
          tooltipComponent:
            this.tokenUser && !this.tokenUser.admin ? null : "TooltipDiagnosis",
        },
        {
          field: "leader",
          headerName: "Liderazgo PHD",
          editable: false,
          filter: "agTextColumnFilter",
          width: "140px",
          cellRenderer: (params) => {
            return this.formatStatus(params);
          },
          getQuickFilterText: (params) => {
            return `liderazgo ${params.value}`;
          },
          onCellClicked: (params) => this.handerCellClicked(params),
          cellStyle: {
            display: "flex",
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            "padding-right": "5",
          },
          tooltipField:
            this.tokenUser && !this.tokenUser.admin ? null : "leader",
          tooltipComponent:
            this.tokenUser && !this.tokenUser.admin ? null : "TooltipDiagnosis",
        },
        /*
                {
                    field: 'created',
                    headerName:'Creado',
                    editable: false,
                    cellRenderer: params => { return this.dateProcess(params.value) },
                    width: 120,
                    cellStyle: {
                        textAlign: 'center',
                        justifyContent: 'center',
                        alignItems: 'center',
                        'padding-right': '5'
                    },
                },
                */
        {
          field: "users",
          headerName: "Usuarios",
          hide: this.tokenUser ? !this.tokenUser.admin : true,
          editable: false,
          width: "100px",
          cellStyle: {
            display: "flex",
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            "padding-right": "5",
          },
          headerTooltip: "Usuarios en la empresa",
        },
        {
          field: "_id",
          headerName: "Controles",
          hide: this.tokenUser ? !this.tokenUser.admin : true,
          colId: "_actions",
          editable: false,
          cellRenderer: "ButtonsActionCompany",
          // cellRendererParams: { tokenUser: this.tokenUser },
        },
      ],
      rowPinningData: [],
      components: {
        ButtonsActionCompany: () => {
          return {
            render: (h) =>
              h(buttonsActionCompany, {
                props: {},
                on: {
                  updateCompany: this.updateCompany,
                },
              }),
          };
        },
        TooltipDiagnosis: () => {
          return {
            render: (h) => h(tooltipDiagnosis),
          };
        },
        CellSelectCompany: () => {
          return {
            render: (h) =>
              h(cellSelectCompany, {
                on: {
                  rowPinning: this.rowPinning,
                },
              }),
          };
        },
        CellHeaderIcon: () => {
          return {
            render: (h) => h(cellHeaderIcon),
          };
        },
      },
      componentMenu: () => {
        return {
          render: (h) =>
            h(menuTableCompany, {
              props: {
                filter: this.filter,
                tokenUser: this.tokenUser,
              },
              on: {
                clearFilter: this.clearFilter,
                switchSideMenu: this.switchSideMenu,
              },
            }),
        };
      },
    };
  },
  computed: {
    isExternalFilterPresent() {
      return () => !!Object.keys(this.filter).length;
    },
    doesExternalFilterPass() {
      return (node) => {
        if (node.data && Object.keys(this.filter).length) {
          const value = this.checkFilter(this.filter.value);
          switch (value) {
            case "climaOld":
              return node.data.climaOld > 0;
            case "leader":
              return node.data.leader > 0;
            case "clima":
              return node.data.clima > 0;
            case "frp":
              return node.data.frp > 0;
            case "frpNew":
              return node.data.frpNew > 0;
            case "graph":
              return this.checkDate(this.filter.value, node);
            default:
              return true;
          }
        }
        return true;
      };
    },
    ...mapState(["empresa"]),
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    filter: {
      type: Object,
      default() {
        return {};
      },
    },
    tokenUser: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
  },
  methods: {
    // Actions
    async handerCellClicked(params) {
      const isClient = this.tokenUser.cliente;
      const type = params.colDef.field;
      // console.log(type);
      const routes = {
        climaOld: {
          cliente: "datamenu/listdata",
          admin: "datamenu/listdata",
          role: ["cliente"],
        },
        clima: {
          cliente: "/clima7/home",
          admin: "/climan",
          role: ["free"],
        },
        frp: {
          cliente: "/listview",
          admin: "/listview",
          role: ["cliente"],
        },
        frpNew: {
          cliente: "/frp",
          admin: "/frp",
          role: ["frp"],
        },
        cultura: {
          cliente: "/cultura",
          admin: "/cultura",
          role: ["cliente"],
        },
        leader: {
          cliente: "/lider",
          admin: "/lider",
          role: ["lider", "ghumana"],
        },
      };

      if (this.validatePermission(routes, type)) {
        this.selectCompany(params.data._id);
        await this.$swal({
          text: `Se selecciono la empresa correctamente. Redireccionando`,
          icon: "success",
          showConfirmButton: false,
          timer: 1700,
        });
        return true;
      }

      const company = this.selectCompany(params.data._id);

      if (params.value > 0) {
        if (company) {
          await this.$swal({
            html: `Proceso <strong>${
              params.data[`${params.colDef.field}ProcessLast`].nombre
            }</strong> seleccionado correctamente.`,
            icon: "success",
            showConfirmButton: false,
            timer: 1700,
          });
        }
        if (!isClient) this.$router.push(routes[type].admin);
        if (isClient) this.$router.push(routes[type].cliente);
      } else {
        if (company) {
          await this.$swal({
            text: `Se selecciono la empresa correctamente. Redireccionando`,
            icon: "success",
            showConfirmButton: false,
            timer: 1700,
          });
        }
        if (!isClient) this.$router.push(routes[type].admin);
        if (isClient) this.$router.push(routes[type].cliente);
      }
    },
    async selectCompany(id) {
      try {
        const change = await apiServices.get(`/changecompany/${id}`);
        const empresa = await apiServices.get(`/empresacredential`);
        if (change.data && empresa.data) {
          this.$store.commit("refreshEmpresa", empresa.data);
          return true;
        }
      } catch (error) {
        console.log(error);
        await this.$swal({
          title: this.params.data.nombre,
          text: "Error al cambiar de empresa.",
          icon: "error",
          showConfirmButton: false,
          timer: 1700,
        });
      }
    },
    applyFilterTable() {
      this.$refs.tableCompanies.gridApi.onFilterChanged();
    },
    clearFilter() {
      this.$emit("setFilter", "");
    },
    switchSideMenu() {
      this.$emit("switchSideMenu");
    },
    updateCompany(data) {
      this.$emit("updateCompany", data);
    },
    // Helpers
    dateProcess(d) {
      let date = new Date(d);
      let options = { year: "numeric", month: "numeric", day: "numeric" };
      date = date.toLocaleDateString(undefined, options);
      return date;
    },
    formatStatus(params) {
      const field = params.colDef.field.toLowerCase();
      const value = params.value;

      if (value === 0) {
        return `<span class="tag is-grey-outline is-capitalized is-flex" style='width: 100% !important;'>No tiene</span>`;
      }

      if (field === "climaold") {
        return `<span class="tag is-purple-outline is-capitalized is-flex" style='width: 100% !important;'><i class="material-icons mr-5">list</i> ${value}</span>`;
      }
      if (field === "leader") {
        return `<span class="tag is-purple-outline is-capitalized is-flex" style='width: 100% !important;'><i class="material-icons mr-5">stars</i> ${value}</span>`;
      }
      if (field === "clima") {
        return `<span class="tag is-purple-outline is-capitalized is-flex" style='width: 100% !important;'><i class="material-icons mr-5">ac_unit</i> ${value}</span>`;
      }
      if (field === "frp") {
        return `<span class="tag is-purple-outline is-capitalized is-flex" style='width: 100% !important;'><i class="material-icons mr-5">blur_on</i> ${value}</span>`;
      }

      if (field === "frpnew") {
        return `<span class="tag is-purple-outline is-capitalized is-flex" style='width: 100% !important;'><i class="material-icons mr-5">blur_on</i> ${value}</span>`;
      }

      if (field === "cultura") {
        return `<span class="tag is-purple-outline is-capitalized is-flex" style='width: 100% !important;'><i class="material-icons mr-5">stream</i> ${value}</span>`;
      }

      return `<span class="tag is-grey is-capitalized" style='width: 100% !important;'>Nan</span>`;
    },
    validatePermission(routes, type) {
      if (this.tokenUser && this.tokenUser.admin) return false;
      const permDiagnostic = routes[type].role.filter((r) => {
        if (this.tokenUser[r]) return true;
      });
      return this.tokenUser && !permDiagnostic.length;
    },
    checkDate(value, node) {
      const date = new Date(node.data.created);
      const month = date.toLocaleString("es-ES", { month: "long" });
      return month.toLowerCase() === value.toLowerCase();
    },
    checkFilter(value) {
      const months = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
      // Validar si en un mes convertirlo a la opcion graph
      if (months.includes(value)) return "graph";
      return value;
    },
    rowPinning() {
      if (this.data && this.empresa) {
        this.rowPinningData = this.data.filter(
          (element) => element._id === this.empresa._id
        );
      } else {
        this.rowPinningData = [];
      }
    },
  },
  watch: {
    filter() {
      this.applyFilterTable();
    },
    data() {
      this.rowPinning();
    },
  },
  components: {
    tableAg,
  },
};
</script>
<style lang="scss">
.table-company .ag-header-cell-label {
  justify-content: center !important;
}
.table-company .ag-header-cell {
  justify-content: center !important;
}

.table-company .ag-header {
  border-radius: 15px;
  border: 1px solid #e5e5e5;
  margin-bottom: 15px;
  background-color: #f3f3f3;
}
/*
.table-company .ag-body {
    border-radius: 15px;
    border: 1px solid #E5E5E5;
}

.table-company .ag-body-viewport {
    border-radius: 15px;
}
*/
.table-company .ag-row-hover:not(.ag-full-width-row)::before,
.ag-row-hover.ag-full-width-row.ag-row-group::before {
  background-color: #f0e3fa87;
}

.ag-cell-value > span {
  width: 100% !important;
}

.is-purple-outline {
  background-color: rgb(244, 236, 250) !important;
  color: rgb(150, 65, 204) !important;
  border: 1px solid rgb(150, 65, 204) !important;
}

.is-purple {
  background-color: rgb(150, 65, 204) !important;
  color: white !important;
}

.is-purple-dark {
  background-color: rgb(109, 53, 172) !important;
  color: white !important;
}

.is-purple-dark-outline {
  background-color: rgba(109, 53, 172, 0.189) !important;
  color: rgb(109, 53, 172) !important;
  border: 1px solid rgb(109, 53, 172) !important;
}

.is-grey-outline {
  background-color: #e5e5e55a !important;
  color: #b4b4b4 !important;
  border: 1px solid #b4b4b4 !important;
}

.mr-5 {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/empresas/components/Table.vue